import { BLLCariKartlar } from './../../../providers/bll/bll-carikart';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { SelectSearchableComponent } from 'ionic-select-searchable';
import { NL_CariKart } from '../../../models/NL_CariKart';


@Component({
  selector: 'page-cek-senet-ekle-guncelle',
  templateUrl: 'cek-senet-ekle-guncelle.html',
})
export class CekSenetEkleGuncellePage {
  @ViewChild('myselect') selectComponent: SelectSearchableComponent;
  secilencari = "";
  eklencektip: number = 0;
  sayfaadi = "";
  evethayir = [];
  suankitarih: any;
  aktifkullaniciadi = "";
  cariListesi: NL_CariKart[] = [];
  veriJson: any = {
    ID: -1, CekSenetNo: "", CekmiSenetmi: "", MusteriCekiMi: "", AlinmaTarihi: "", VadeTarihi: "", CariID: "", Banka: "", HesapNo: ""
    , Iban: "", Tutar: "", SonDurum: 1, CekSenetAsilSahibi: "", BakiyeEtkilesinmi: 0, GirisMi: "", CiroEdilmisMi: ""
    , CiroEdilenCariID: "", CiroEdilmeTarihi: "", Aciklama: ""
  };
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public toast: ToastController,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    this.suankitarih = this.ortak.tarih(this.suankitarih);
    this.veriJson.AlinmaTarihi = this.suankitarih;
    this.aktifkullaniciadi = this.ortak.aktifKullaniciAdi;
    if (navParams.get("tip") != null) {
      this.eklencektip = navParams.get("tip");
    }
    if (this.eklencektip == 1) {
      this.sayfaadi = "Müşteri Çeki Ekle";
    }
    if (this.eklencektip == 2) {
      this.sayfaadi = "Müşteri Seneti Ekle";
    }
    if (this.eklencektip == 3) {
      this.sayfaadi = "Çek Çıkışı";
    }
    if (this.eklencektip == 4) {
      this.sayfaadi = "Senet Çıkışı";
    }
    this.evethayir = [{
      "ID": "0",
      "Adi": "Hayır"
    },
    {
      "ID": "1",
      "Adi": "Evet"
    }
    ];
  }
  userChanged(event: { Component: SelectSearchableComponent, value: any }) {
    if (event.value != null) {
      this.veriJson.CariID = event.value.ID;
    }
  }

  openFromCode() {
    this.selectComponent.open();
  }

  ionViewDidLoad() {
    this.CarileriGetir();
  }
  Kaydet() {
    if (this.eklencektip == 1)//Müşteri Çeki
    {
      this.veriJson.CekmiSenetmi = 1;
      this.veriJson.GirisMi = 1;
      this.veriJson.MusteriCekiMi = 1;
    }
    if (this.eklencektip == 2)//Müşteri Seneti
    {
      this.veriJson.CekmiSenetmi = 2;
      this.veriJson.GirisMi = 1;
      this.veriJson.MusteriCekiMi = 1;
    }
    if (this.eklencektip == 3)//Verilen Çek
    {
      this.veriJson.CekmiSenetmi = 1;
      this.veriJson.GirisMi = 0;
      this.veriJson.MusteriCekiMi = 0;
    }
    if (this.eklencektip == 4)//VErilen Senet
    {
      this.veriJson.CekmiSenetmi = 2;
      this.veriJson.GirisMi = 0;
      this.veriJson.MusteriCekiMi = 0;
    }

    if (this.boslukKontrol()) {
      var formdata = new FormData();
      formdata.append("gelenveri", JSON.stringify(this.veriJson));
      formdata.append("islemiyapan", this.aktifkullaniciadi);
      this.bllOrtak.islem(formdata, "CekSenetEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) {
          this.ortak.showBasicAlert("Başarılı", "İşlem Kaydedildi");
          this.kapat();
        }

        if (sonuc.Sonuc != 1) this.ortak.showBasicAlert("Hata", "Beklenmedik bir hata oluştu");
      })
    }
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.veriJson.CekSenetNo == null || this.veriJson.CekSenetNo == "") {
      mesaj = mesaj + "Lütfen belge numarası  giriniz. <br/>";
    }

    if (this.veriJson.Banka == null || this.veriJson.Banka == "") {
      mesaj = mesaj + "Lütfen banka adını giriniz. <br/>";
    }
    if (this.veriJson.Tutar == null || this.veriJson.Tutar == "") {
      mesaj = mesaj + "Lütfen geçerli bir tutar giriniz. <br/>";
    }
    if (this.veriJson.VadeTarihi == null || this.veriJson.VadeTarihi == "") {
      mesaj = mesaj + "Lütfen vade tarihi  seçiniz. <br/>";
    }
    if (this.veriJson.CariID == null || this.veriJson.CariID == "") {
      mesaj = mesaj + "Lütfen cari hesap seçiniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }

  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  CarileriGetir() {
    // var bllcariler = new BLLCariKartlar();
    // bllcariler.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(Definition_,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş')like '%" + "" + "%' or Kodu='" + "" + "')" + " order by Definition_").then(a => {
    //   this.cariListesi = a;


    // })

    var formData = new FormData();
    formData.append("aranan", "");
  
    formData.append("skip", "0");
    formData.append("take", "1000");
 
    this.bllOrtak.islem(formData, "MusteriSec","", false).then(a => {
     
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
     
  
 
    })
    
  
  
  }

}



// WEBPACK FOOTER //
// ./src/pages/CekSenetIslemleri/cek-senet-ekle-guncelle/cek-senet-ekle-guncelle.ts